// TEMPORARY: This file exports all country-specific bucket setting overrides
// This will not be needed once buckets configuration is moved to DB
// Add new overrides by importing them here and adding them to the default export
// When you create a new override file (e.g., DE.ts), import it and add it to the overrides object

import type { PartialRecursive } from '@bridebook/models/source/abstract/_';
import type { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';
import type { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import IE from './IE';
import DE from './DE';
import FR from './FR';

const overrides: Partial<Record<CountryCodes, PartialRecursive<IBucket['settings']>>> = {
  IE,
  DE,
  FR,
};

export default overrides;
